//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackButton from "./back-button";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PageHeader",
  components: {
    BackButton
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "col-9"
    },
    containerClass: {
      type: String,
      default: "w-100 mb-4"
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    staticBackRoute: {
      type: String,
      default: null
    },
    titleClass: {
      type: String,
      default: "page-header"
    }
  }
});